import {
  ISearchFieldConfig,
  SearchFieldType,
} from "../../../../components/advanced-search/AdvancedSearch.interface";

export const companySearchConfig: ISearchFieldConfig[] = [
  {
    type: SearchFieldType.DATE_RANGE,
    label: "Created date",
    key: "from",
    rangeEndKey: "to",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
  {
    type: SearchFieldType.SEARCH_BY_COMPANY_DROPDOWN,
    label: "Search by company",
    key: "companyId",
  },
];
